import { render, staticRenderFns } from "./orgOwnerAlertBanner.vue?vue&type=template&id=20824626&"
import script from "./orgOwnerAlertBanner.vue?vue&type=script&lang=js&"
export * from "./orgOwnerAlertBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports